import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';

const Main = styled.main`
  min-height: calc(100vh - 160px); /* Adjust based on your navbar and footer height */
  background-color: ${props => props.theme.primaryBg};
  color: ${props => props.theme.primaryText};
  transition: background-color 0.3s ease, color 0.3s ease;
`;

const Layout = ({ children }) => {
  const { theme } = useTheme();
  
  return (
    <>
      <Navbar />
      <Main theme={theme}>{children}</Main>
      <Footer />
    </>
  );
};

export default Layout; 